import { render, staticRenderFns } from "./simplifyShopOwnerShops.vue?vue&type=template&id=e24b000a&scoped=true"
import script from "./simplifyShopOwnerShops.vue?vue&type=script&lang=js"
export * from "./simplifyShopOwnerShops.vue?vue&type=script&lang=js"
import style0 from "./simplifyShopOwnerShops.vue?vue&type=style&index=0&id=e24b000a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24b000a",
  null
  
)

export default component.exports